/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuCrossOwnerDocsSynchronizeCreateRequest = {} | null | undefined;
export type SvuCrossOwnerDocsSynchronizeCreateResponse = any;

export type SvuCrossOwnerDocsSynchronizeCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/synchronize/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_synchronize_create
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSynchronizeCreateOperation = ({
  id,
  ...rest
}: SvuCrossOwnerDocsSynchronizeCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/svu_cross_owner_docs/${id}/synchronize/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/svu_cross_owner_docs/{id}/synchronize/' };
  };

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/synchronize/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_synchronize_create
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSynchronizeCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuCrossOwnerDocsSynchronizeCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuCrossOwnerDocsSynchronizeCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
